import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = { role: ROLE.SUPER_ADMIN };

const path = "admin/puja"

export const List = async (values) => {
    return await axiosInstance(options).post(`${path}/list`, values);
}

export const Add = async (values) => {
    return await axiosInstance(options).post(`${path}/add`, values);
}

export const Update = async (values) => {
    return await axiosInstance(options).put(`${path}/update`, values);
}

export const Details = async (id) => {
    return await axiosInstance(options).get(`${path}/details?id=${id}`);
}

export const Status = async (values) => {
    return await axiosInstance(options).put(`${path}/change-status`, values);
}

export const Delete = async (values) => {
    return await axiosInstance(options).post(`${path}/delete`, values);
}

// Puja Booking Services
const bookingPath = "admin/puja/puja-booking";

export const BookingList = async (values) => {
    return await axiosInstance(options).post(`${bookingPath}/list`, values);
}

export const AssignAstrologer = async (values) => {
    return await axiosInstance(options).post(`${bookingPath}/assign-astrologer`, values);
}

export const UpdateStatus = async (values) => {
    return await axiosInstance(options).post(`${bookingPath}/update-status`, values);
}

export const RescheduleBooking = async (values) => {
    return await axiosInstance(options).post(`${bookingPath}/reschedule`, values);
}

export const BookingDetails = async (id) => {
    return await axiosInstance(options).get(`${bookingPath}/details?id=${id}`);
}

export const BookingHistory = async (bookingId) => {
    const formData = new FormData();
    formData.append("booking_id", bookingId);
    return await axiosInstance(options).post(`${bookingPath}/history`, formData);
}